import { Progress, Stack, Text } from '@chakra-ui/react';
import { FormatPrice } from 'components/localisation/FormatPrice';

interface CartFreeShippingProgressProps {
  subtotal: number;
  threshold: number;
}

export function CartFreeShippingProgress({
  subtotal,
  threshold,
}: CartFreeShippingProgressProps) {
  const remainingCents =
    Math.round(threshold * 100) - Math.round(subtotal * 100);
  const remaining = remainingCents / 100;
  const isUnlocked = remainingCents <= 0;
  const percentage = isUnlocked ? 100 : (subtotal / threshold) * 100;

  return (
    <Stack spacing="4xs" mt="4xs" mb="sm">
      {isUnlocked ? (
        <Text size="detail" color="blackAlpha.700">
          Congrats! You&apos;ve unlocked{' '}
          <Text as="span" size="detail" fontWeight="medium" color="green.600">
            Free Shipping
          </Text>
        </Text>
      ) : (
        <Text size="detail" color="blackAlpha.700">
          <Text as="span" size="detail" fontWeight="medium" color="gray.600">
            Unlock free shipping.
          </Text>{' '}
          <FormatPrice amount={remaining} isCurrencyCodeHidden /> away from free
          shipping.
        </Text>
      )}
      <Progress
        aria-label="Progress towards free shipping"
        value={percentage}
        h="5xs"
        bg="gray.200"
        borderRadius="full"
        sx={{
          div: {
            bg: isUnlocked ? 'green.300' : 'gray.600',
            transition: 'width 0.3s ease',
          },
        }}
      />
    </Stack>
  );
}
